module.exports = __webpack_public_path__ + "media/images/technology/paper-icon-64068c1b93a49f107d3a24645393623e.png";